import 'mustache';
import $ from 'jquery';
import 'jquery-Mustache';

/**
 * Adds a render method which returns a jQuery object instead of text.
 */
$.extend($.Mustache, {
    jQ: function (templateName, templateData) {
        return $($.Mustache.render(templateName, templateData));
    }
});

// initialize Mustache templates
$.Mustache.addFromDom();


// WEBPACK FOOTER //
// ./init/mustache.js